import React from 'react';
import { useTranslation } from 'react-i18next';
import RowResumeText from '../../../../../../components/RowResumeText';
import { EMPTY_VALUES, getDateFormat } from '../../../../../../Apis/functions';
import ResumeInfoCard from '../../../../../../components/ResumeInfoCard';
import { DocumentLinesIcon, UserDocumentIcon } from '../../../../../../components/buttons/IconButtons';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const SummaryEmployeeContractCard = ({
    employeeData,
    employeeRoles,
    employeeWorkStations,
    employeeDepartments,
    isPilgrimsValidation,
}) => {
    const { t } = useTranslation();
    return (
        <ResumeInfoCard
            title={t('contract')}
            titleIcon={<UserDocumentIcon width={24} height={24} />}
            icon={<DocumentLinesIcon className='btn-icon-svg-24px' />}
            iconClass='background-primary-100'
            contentClass={"py-3"}
            body={
                <div className='grid-container-resume-data mb-2'>
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('privilege')}
                        value={employeeRoles.find((item) => item.id === employeeData?.roleId)?.name || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('employee_id')}
                        value={employeeData?.employeeId}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('ceco')}
                        value={employeeData?.cecoCode || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('work_station')}
                        value={employeeWorkStations.find((item) => item.id === employeeData?.zoneId)?.name || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t(isPilgrimsValidation ? 'work_group' : 'department')}
                        value={employeeDepartments.find((item) => item.id === employeeData?.departmentId)?.name || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('start_date')}
                        value={getDateFormat(employeeData?.startDate, false)}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('end_date')}
                        value={getDateFormat(employeeData?.endDate, false)}
                    />
                </div>
            }
        />
    );
};

export default SummaryEmployeeContractCard;
